import { Component, effect, inject, signal } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { ActivatedRoute } from '@angular/router';
import { Timestamp } from '@angular/fire/firestore';
import { of, switchMap } from 'rxjs';
import { ServiceBookShareService } from '../../services/service-book-share.service';

@Component({
  selector: 'app-service-book-share-view',
  templateUrl: './service-book-share-view.component.html',
  styleUrl: './service-book-share-view.component.css'
})
export class ServiceBookShareViewComponent {
  private readonly route = inject(ActivatedRoute);
  private readonly shares = inject(ServiceBookShareService);
  readonly loading = signal(true);
  private recordedToken: string | null = null;

  readonly share = toSignal(this.route.paramMap.pipe(
    switchMap(params => {
      const token = params.get('token') ?? '';
      return token ? this.shares.watchShare(token) : of(null);
    })
  ), { initialValue: null });

  constructor() {
    effect(() => {
      const share = this.share();
      if (!share || this.shares.isExpired(share) || this.recordedToken === share.token) return;
      this.recordedToken = share.token;
      // Analytics must never prevent a recipient from reading the shared book.
      void this.shares.recordShareView(share.token, this.shares.createViewId()).catch(() => undefined);
    });
  }

  expiresLabel(value: Date | Timestamp | undefined | null): string {
    if (!value) return '';
    const date = value instanceof Date ? value : value.toDate();
    return date.toLocaleString();
  }

  isExpired(): boolean {
    const share = this.share();
    return !!share && this.shares.isExpired(share);
  }
}
